export default __webpack_public_path__ + "static/media/mvp-3.34085e8c.png";